import React from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './main.css';
import { Typography } from '@material-ui/core';
import AppearingElement from "../Helper/AppearingElement";
import Confused from "../images/Confused.png";

function Mountain(props) {
    AOS.init();
    return (
        <AppearingElement variant="custom" className="mountain-app" threshold={0.4}>
            <Typography className="mountain__list-title-app" variant="h2">{props.title}</Typography>
            <div className="mountain__container-app">
                <img src={Confused} className="mountain__video-app" alt="" />
                {!props.small &&
                    <div>
                        <Typography className="mountain__list-item-app" data-aos="fade-down" data-aos-duration="2000" variant="h4">Slow Onboarding and Training</Typography>
                        <Typography className="mountain__list-item1-app" data-aos="fade-down" data-aos-delay="1200" data-aos-duration="2000" variant="h3">High # of tickets</Typography>
                        <Typography className="mountain__list-item2-app" data-aos="fade-down" data-aos-delay="300" data-aos-duration="2000" variant="h5">Inefficient Classroom/Education Sessions</Typography>
                        <Typography className="mountain__list-item3-app" data-aos="fade-down" data-aos-delay="1800" data-aos-delay="2000" data-aos-duration="2000" variant="h4">Outdated video tutorials and captivate recordings</Typography>
                        <Typography className="mountain__list-item4-app" data-aos="fade-down" data-aos-delay="600" data-aos-duration="2000" variant="h3">Inconsistent screenshots</Typography>
                        <Typography className="mountain__list-item5-app" data-aos="fade-down" data-aos-delay="1600" data-aos-duration="2000" variant="h5">End-User confusion and frustration</Typography>
                        <Typography className="mountain__list-item6-app" data-aos="fade-down" data-aos-delay="900" data-aos-duration="2000" variant="h5">Low information retention levels</Typography>
                    </div>
                }
                {props.small &&
                    <div>
                        <Typography className="mountain__list-item-app" data-aos="fade-down" data-aos-duration="2000" variant="h4">Slow Onboarding and Training</Typography>
                        <Typography className="mountain__list-item1-app" data-aos="fade-down" data-aos-delay="1200" data-aos-duration="2000" variant="h3">High # of tickets</Typography>
                        <Typography className="mountain__list-item2-app" data-aos="fade-down" data-aos-delay="300" data-aos-duration="2000" variant="h5">Inefficient Classroom/Education Sessions</Typography>
                        <Typography className="mountain__list-item3-app" data-aos="fade-down" data-aos-delay="1800" data-aos-delay="2000" data-aos-duration="2000" variant="h4">Outdated video tutorials and captivate recordings</Typography>
                        <Typography className="mountain__list-item4-app" data-aos="fade-down" data-aos-delay="600" data-aos-duration="2000" variant="h3">Inconsistent screenshots</Typography>
                        <Typography className="mountain__list-item5-app" data-aos="fade-down" data-aos-delay="1600" data-aos-duration="2000" variant="h5">End-User confusion and frustration</Typography>
                        <Typography className="mountain__list-item6-app" data-aos="fade-down" data-aos-delay="900" data-aos-duration="2000" variant="h5">Low information retention levels</Typography>
                    </div>

                }
            </div>

        </AppearingElement>
    )
}

export default Mountain
